import { Hero } from "./components/Hero";
import { Footer, MediaSection, SoftwareSection } from "./components/Sections";
import { TextLink } from "./components/TextLink";
import { site } from "./content";

export function App() {
  return (
    <div className="page" id="top">
      <a className="skip-link" href="#main">Skip to content</a>
      <header className="site-header">
        <a className="wordmark" href="#top" aria-label="Usubi Lab. home">
          {site.name}
        </a>
        <TextLink className="contact-link" href={`mailto:${site.email}`}>
          {site.email}
        </TextLink>
      </header>
      <main id="main" tabIndex={-1}>
        <Hero />
        <SoftwareSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}
